import styled from '@emotion/styled';
import { Dropdown } from 'semantic-ui-react';

export const HighDropdown = styled(Dropdown)`
	& .menu {
		max-height: 500px !important;
	}
`;
